export const measurementTypes = [
    'Temperature',
    'Pressure',
    'Flow',
    'Speed',
    'Velocity',
    'Voltage',
    'Current',
    'Resistance',
    'Frequency',
    'Power',
    'Energy'
];
export const units = {
    Temperature:[
        { name: "Degree Celsius", symbol: "°C" },
        { name: "Kelvin", symbol: "K" },
        { name: "Degree Fahrenheit", symbol: "°F" },
        { name: "Rankine", symbol: "°R" },
        { name: "Percentage", symbol: "%"}
    ],
    Pressure:[
        { name: "Pascal", symbol: "Pa" },
        { name: "Kilopascal", symbol: "kPa" },
        { name: "Bar", symbol: "bar" },
        { name: "Atmosphere", symbol: "atm" },
        { name: "Millimeter of Mercury", symbol: "mmHg" },
        { name: "Pound per Square Inch", symbol: "psi" },
        { name: "Torr", symbol: "Torr" },
        { name: "Percentage", symbol: "%"}
    ],
    Flow:[
        { name: "Liters per Minute", symbol: "L/min" },
        { name: "Cubic Meters per Hour", symbol: "m³/h" },
        { name: "Gallons per Minute", symbol: "GPM" },
        { name: "Cubic Feet per Minute", symbol: "CFM" },
        { name: "Percentage", symbol: "%"}
    ],
    Speed:[
        { name: "Meters per Second", symbol: "m/s" },
        { name: "Kilometers per Hour", symbol: "km/h" },
        { name: "Miles per Hour", symbol: "mph" },
        { name: "Knots", symbol: "kn" },
        { name: "Revolutions per Minute", symbol: "RPM" },
        { name: "Percentage", symbol: "%"}
    ],
    Velocity:[
        { name: "Meters per Second", symbol: "m/s" },
        { name: "Kilometers per Hour", symbol: "km/h" },
        { name: "Miles per Hour", symbol: "mph" },
        { name: "Knots", symbol: "kn" },
        { name: "Revolutions per Minute", symbol: "RPM" },
        { name: "Percentage", symbol: "%"}
    ],
    Voltage:[
        { name: "Millivolt", symbol: "mV" },
        { name: "Volt", symbol: "V" },
        { name: "Kilovolt", symbol: "kV" },
        { name: "Megavolt", symbol: "MV" },
        { name: "Percentage", symbol: "%"}
    ],
    Current:[
        { name: "Microampere", symbol: "µA" },
        { name: "Milliampere", symbol: "mA" },
        { name: "Ampere", symbol: "A" },
        { name: "Kiloampere", symbol: "kA" },
        { name: "Percentage", symbol: "%"}
    ],
    Resistance:[
        { name: "Milliohm", symbol: "mΩ" },
        { name: "Ohm", symbol: "Ω" },
        { name: "Kiloohm", symbol: "kΩ" },
        { name: "Megaohm", symbol: "MΩ" },
        { name: "Percentage", symbol: "%"}
    ],
    Frequency:[
        { name: "Hertz", symbol: "Hz" },
        { name: "Kilohertz", symbol: "kHz" },
        { name: "Megahertz", symbol: "MHz" },
        { name: "Gigahertz", symbol: "GHz" },
        { name: "Percentage", symbol: "%"}
    ],
    Power:[
        { name: "Watt", symbol: "W" },
        { name: "Kilowatt", symbol: "kW" },
        { name: "Megawatt", symbol: "MW" },
        { name: "Gigawatt", symbol: "GW" },
        { name: "Horsepower", symbol: "HP" },
        { name: "Percentage", symbol: "%"}
    ],
    Energy:[
        { name: "Joule", symbol: "J" },
        { name: "Kilojoule", symbol: "kJ" },
        { name: "Calorie", symbol: "cal" },
        { name: "Kilocalorie", symbol: "kcal" },
        { name: "Percentage", symbol: "%"}
    ]
};